import { TASK_DISTRIBUTE_METHOD } from '@/constant/taskConstant';
import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { TaskApi } from '@/type';
import { apiOf } from '@/util';

export const create = apiOf<TaskApi.Create.Request, TaskApi.Create.Response>(
  new AxiosPostRequestOptions({ url: '/v1/miri/project/:pProjectID/task' }),
);

export const getDetail = apiOf<
  TaskApi.GetDetail.Request,
  TaskApi.GetDetail.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/task/:pTaskID' }));

export const getList = apiOf<TaskApi.GetList.Request, TaskApi.GetList.Response>(
  new AxiosGetRequestOptions({ url: '/v1/miri/task' }),
);

export const getCount = apiOf<
  TaskApi.GetCount.Request,
  TaskApi.GetCount.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/task/count' }));

export const update = apiOf<TaskApi.Update.Request, TaskApi.Update.Response>(
  new AxiosPutRequestOptions({ url: '/v1/miri/task/:pTaskID' }),
);

export const remove = apiOf<TaskApi.Delete.Request, TaskApi.Delete.Response>(
  new AxiosDeleteRequestOptions({ url: '/v1/miri/task/:pTaskID' }),
);

export const exportLabel = apiOf<
  TaskApi.ExportLabel.Request,
  TaskApi.ExportLabel.Response
>(
  new AxiosPostRequestOptions({ url: 'v1/miri/task/:pTaskID/exportLabelData' }),
);

export const requestTaskPreAnnotation = apiOf<
  TaskApi.PreAnnotation.Request,
  TaskApi.PreAnnotation.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/preAnnotation',
  }),
);

export const requestDeployment = apiOf<
  TaskApi.Deployment.Request,
  TaskApi.Deployment.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/modelBuild',
  }),
);

export const modelTraining = apiOf<
  TaskApi.ModelTraining.Request,
  TaskApi.ModelTraining.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/modelTraining',
  }),
);

export const cancelOperation = apiOf<
  TaskApi.CancelOperation.Request,
  TaskApi.CancelOperation.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/operation/cancel',
  }),
);

export const distributeByRange = apiOf<
  TaskApi.Distribute.Request<TASK_DISTRIBUTE_METHOD.RANGE>,
  TaskApi.Distribute.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/distribute',
  }),
);

export const distributeByRatio = apiOf<
  TaskApi.Distribute.Request<TASK_DISTRIBUTE_METHOD.RATIO>,
  TaskApi.Distribute.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/task/:pTaskID/distribute',
  }),
);

export const getDistributePreview = apiOf<
  TaskApi.GetDistributePreview.Request,
  TaskApi.GetDistributePreview.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/task/:pTaskID/distribute-preview',
    defaultData: {
      method: TASK_DISTRIBUTE_METHOD.RATIO,
    },
  }),
);
